import { render, staticRenderFns } from "./paragraph.vue?vue&type=template&id=204ed652"
import script from "./paragraph.vue?vue&type=script&lang=js"
export * from "./paragraph.vue?vue&type=script&lang=js"
import style0 from "./paragraph.vue?vue&type=style&index=0&id=204ed652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports